/* istanbul ignore file */
import { FieldProps, TextField, useFieldHelper } from 'framework/ui/field';
import BudgetLink from './BudgetLink';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';

const BudgetLinkField = ({ source, nameSource, ...props }: FieldProps) => {
  const { getValue: getId } = useFieldHelper({ source });
  const { getValue: getName } = useFieldHelper({ source: nameSource });

  const value = getId() ? <BudgetLink name={getName()} id={getId()} {...props} /> : EMPTY_VALUE_INDICATOR;

  return <TextField value={value} {...props} />;
};

export default BudgetLinkField;
